import React from "react";
import { Link } from "react-router-dom";



const MembJoinLink = ({membJoinLinkTxt}:any) => {
    return(
        <>
        <div className="membJoinLinkWrap">
            <ul>
                <li>
                    <Link to="/MembFindId">
                        <p>{membJoinLinkTxt[0]}</p>
                    </Link>
                </li>
                <li>
                    <Link to="/MembFindPw">
                        <p>{membJoinLinkTxt[1]}</p>
                    </Link>
                </li>
                <li>
                    <Link to="/MembJoin">
                        <p>{membJoinLinkTxt[2]}</p>
                    </Link>
                </li>
            </ul>
        </div>
        </>
    )
}

export default MembJoinLink;

